import { useEffect, useState } from "react";
import { useIsMobile } from "~/hook/use-mobile";
import { LiveData } from "~/interface/home/home";
import { cn } from "~/lib/utils";
import { Carousel, CarouselApi, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "../ui/carousel";
import LiveDataCard from "./LiveDataCard";

interface LiveTvRadioCarouselProps {
  data: LiveData[];
  selectedTab: string;
  handleOnTVClick: (type: string) => void;
}

const LiveTvRadioCarousel = ({ data, selectedTab, handleOnTVClick }: LiveTvRadioCarouselProps) => {
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  const [api, setApi] = useState<CarouselApi>();
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!api) {
      return;
    }

    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);

    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);

  return (
    <div className="w-full flex flex-col justify-center items-center gap-between-dot-and-content  ">
      <Carousel
        setApi={setApi}
        className="w-full px-3 relative "
        opts={{
          loop: isMobile ? true : false,
          dragFree: true,
          containScroll: "trimSnaps",
        }}
      >
        <CarouselContent>
          {data.map((data, index) => (
            <CarouselItem key={index} className="md:basis-1/2">
              <div>
                <LiveDataCard data={data} selectedTab={selectedTab} handleOnTVClick={handleOnTVClick} />
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <div className="hidden absolute -bottom-6 left-1/2 -translate-x-1/2 gap-2">
          <CarouselPrevious className="!bg-darkOrangeColor hover:bg-hoverColor hover:text-textHeadingColor !text-white shadow-md border-none rounded-full w-8 h-8 flex items-center justify-center" />
          <CarouselNext className="!bg-darkOrangeColor hover:bg-hoverColor hover:text-textHeadingColor !text-white border-none shadow-md rounded-full w-8 h-8 flex items-center justify-center" />
        </div>
      </Carousel>
      {/* Dot Indicators */}
      <div className="flex justify-center items-center gap-2">
        {Array.from({ length: count }, (_, index) => (
          <button
            key={index}
            className={cn(
              "w-3 h-1 rounded-full transition-all duration-300 ease-in-out",
              current === index + 1 ? "bg-textHeadingColor w-8 shadow-lg" : "bg-lightbackground hover:scale-110",
            )}
            onClick={() => api?.scrollTo(index)}
            aria-label={`Go to heritage ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default LiveTvRadioCarousel;
